import {
  POST_AGENT_REPORT_INFO,
  POST_AGENT_REPORT_LEARNINGSITUATION,
  POST_AGENT_REPORT_LEARNINGTIME,
  POST_AGENT_REPORT_WORDCLOUD,
  POST_AGENT_REPORT_COURSEEXAMINFO,
  POST_AGENT_REPORT_CERTEXAMINFO,
  POST_AGENT_REPORT_RADARCHAR,
  POST_AGENT_REPORT_TABLECHAR,
  POST_AGENT_REPORT_LEARNINGTOPLIST,
  POST_AGENT_REPORT_OFFLINEDATA,
  POST_AGENT_REPORT_EXAM_TOPLIST,
  POST_AGENT_REPORT_SEA_OFFLINE_DATA,
  POST_AGENT_REPORT_CERT_PASS_NUM
} from "@/api/apiConst/agentReport";
import request from "@/api/http/request";

// 代理报告 基础信息
export interface AgentReportInfoType {
  /**
   * 代理商名称
   */
  agent: string;
  /**
   * 季度
   */
  quarter: number;
  /**
   * 年度
   */
  year: number;
  /**
   * 代理商类型
   */
  agentType: number;
}
export function getAgentReportInfo(data: {
  agent: string;
  yearQuarter: string;
}) {
  return request.post<AgentReportInfoType>(POST_AGENT_REPORT_INFO, data);
}

// 代理报告 学习情况
export interface AgentReportLearningSituationType {
  /**
   * 代理商名称
   */
  agent: string;
  /**
   * 平均学习时长
   */
  avgLearningTime: string;
  /**
   * 平均学习时长格式化值
   */
  avgLearningTimeLabel: string;
  /**
   * 超越值
   */
  countSurpass: string;
  /**
   * 季度
   */
  quarter: number;
  /**
   * 排名
   */
  ranking: number;
  /**
   * 活跃人数
   */
  totalActiveNum: number;
  /**
   * 共计学习时长
   */
  totalLearningTime: string;
  /**
   * 共计学习时长格式化值
   */
  totalLearningTimeLabel: string;
  /**
   * 学员总数
   */
  totalStudentNum: number;
  /**
   * 年度
   */
  year: number;
}
export function getAgentReportLearningSituation(data: {
  agent: string;
  yearQuarter: string;
}) {
  return request.post<AgentReportLearningSituationType>(
    POST_AGENT_REPORT_LEARNINGSITUATION,
    data
  );
}

// 代理报告 学习时长
export interface AgentReportLearningTimeType {
  /**
   * 代理平均学习时间
   */
  agentTime: string;
  /**
   * 代理平均学习时间格式化值
   */
  agentTimeLabel: string;
  /**
   * 全国平均学习时间
   */
  allTime: string;
  /**
   * 全国平均学习时间格式化值
   */
  allTimeLabel: string;
  /**
   * top5值
   */
  top: {
    agent: string;
    avgLearningTime: string;
    avgLearningTimeLabel: string;
  }[];
}
export function getAgentReportLearningTime(data: {
  agent: string;
  yearQuarter: string;
}) {
  return request.post<AgentReportLearningTimeType>(
    POST_AGENT_REPORT_LEARNINGTIME,
    data
  );
}

export function getAgentReportCertPassNum(data: {
  agent: string;
  yearQuarter: string;
}) {
  return request.post<AgentReportLearningTimeType>(
    POST_AGENT_REPORT_CERT_PASS_NUM,
    data
  );
}

// 代理报告 词云
export interface AgentReportWordCloudType {
  [property: string]: any;
}
export function getAgentReportWordCloud(data: {
  agent: string;
  yearQuarter: string;
}) {
  return request.post<AgentReportWordCloudType>(
    POST_AGENT_REPORT_WORDCLOUD,
    data
  );
}

// 代理报告 完课考试信息
export interface AgentReportCourseExamInfoType {
  /**
   * 代理商名称
   */
  agent: string;
  /**
   * 超越值
   */
  countSurpass: string;
  /**
   * 考试次数
   */
  examNum: number;
  /**
   * 季度
   */
  quarter: number;
  /**
   * 排行
   */
  ranking: number;
  /**
   * 通过率
   */
  rate: string;
  /**
   * 通过率
   */
  rateDoubleValue: number;
  /**
   * 学员总人数
   */
  totalNum: number;
  /**
   * 年度
   */
  year: number;
  [property: string]: any;
}
export function getAgentReportCourseExamInfo(data: {
  agent: string;
  yearQuarter: string;
}) {
  return request.post<AgentReportCourseExamInfoType>(
    POST_AGENT_REPORT_COURSEEXAMINFO,
    data
  );
}

// 代理报告 认证考试信息
export interface AgentReportCertExamInfoType {
  /**
   * 新增通过人名单
   */
  addList: {
    /**
     * 学员ID
     */
    studentId?: string;
    /**
     * 学员名称
     */
    studentName?: string;
    [property: string]: any;
  }[];
  /**
   * 文案信息
   */
  examInfo: {
    /**
     * 代理商简称
     */
    agent: string;
    /**
     * 初阶季度总通过人数
     */
    quarterLevel1PassNum: number;
    /**
     * 中阶季度总通过人数
     */
    quarterLevel2PassNum: number;
    /**
     * 高阶季度总通过人数
     */
    quarterLevel3PassNum: number;
    /**
     * 季度总通过人数
     */
    quarterPassNum: number;
    /**
     * 季度总通过人数排名
     */
    quarterPassRanking: number;
    /**
     * 初阶总通过人数
     */
    totalLevel1PassNum: number;
    /**
     * 中阶总通过人数
     */
    totalLevel2PassNum: number;
    /**
     * 高阶总通过人数
     */
    totalLevel3PassNum: number;
    /**
     * 总通过人数
     */
    totalPassNum: number;
    /**
     * 总通过人数排名
     */
    totalPassRanking: number;
    [property: string]: any;
  };
  /**
   * 整体所有代理平均认证通过率
   */
  overAllPassRate: string;
  /**
   * 本季度所有代理平均认证通过率
   */
  quarterRate: string;
  [property: string]: any;
}
export function getAgentReportCertExamInfo(data: {
  agent: string;
  yearQuarter: string;
}) {
  return request.post<AgentReportCertExamInfoType>(
    POST_AGENT_REPORT_CERTEXAMINFO,
    data
  );
}

// 代理报告 雷达图
export interface AgentReportRadarCharType {
  [property: string]: any;
}
export function getAgentReportRadarChar(data: {
  agent: string;
  yearQuarter: string;
}) {
  return request.post<AgentReportRadarCharType>(
    POST_AGENT_REPORT_RADARCHAR,
    data
  );
}

// 代理报告 表格
export interface AgentReportTableCharType {
  [property: string]: any;
}
export function getAgentReportTableChar(data: {
  agent: string;
  yearQuarter: string;
}) {
  return request.post<AgentReportTableCharType>(
    POST_AGENT_REPORT_TABLECHAR,
    data
  );
}

export interface AgentReportLearningTopType {
  agent: string;
  studentName: string;
  totalLearningTime: string;
  ranking: number;
  introduction: string;
  year: number;
  quarter: number;
}
export function getAgentReportLearningTopList(data: {
  agent: string;
  yearQuarter: string;
}) {
  return request.post<AgentReportLearningTopType[]>(
    POST_AGENT_REPORT_LEARNINGTOPLIST,
    data
  );
}

export function getagentreportOffLineData(data: {
  agent: string;
  yearQuarter: string;
}) {
  return request.post<{ personCount: number; sessionNum: number }>(
    POST_AGENT_REPORT_OFFLINEDATA,
    data
  );
}
export function getAgentReportExamTopList(data: {
  agent: string;
  yearQuarter: string;
}) {
  return request.post<AgentReportLearningTopType[]>(
    POST_AGENT_REPORT_EXAM_TOPLIST,
    data
  );
}
export interface AgentReportSeaOfflineDataType {
  activeStudentNum: string;
  activeStudentRatio: string;
  agentName: string;
  completeCoursePassRatio: string;
  completeCourseRatio: string;
}
export function getAgentReportSeaOfflineData(data: {
  agent: string;
  yearQuarter: string;
}) {
  return request.post<AgentReportSeaOfflineDataType>(
    POST_AGENT_REPORT_SEA_OFFLINE_DATA,
    data
  );
}
